<template>
  <div v-if="fixDate" class="date">
    {{ fixDate }} <span class="date__author">{{ author }}</span>
  </div>
</template>

<script>
import { months } from "../../config";

export default {
  name: "SearchDate",
  props: {
    text: {
      type: [String, Number],
      default: null,
    },
    min: {
      type: Boolean,
      default: false,
    },
    author: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      months,
    };
  },
  computed: {
    fixDate() {
      let date = "";
      if (this.text) {
        let value = this.text;
        if (typeof this.text === "string") {
          const text = this.text.trim();
          value = text.substring(0, 10).replace(/-/g, "/");
        }
        const newDate = new Date(value * 1000);
        if (newDate) {
          const day = newDate.getDate();
          const month = newDate.getMonth();
          const year = newDate.getFullYear();
          const monthName = this.months.find((el) => el.id === month);
          if (monthName)
            date =
              (day < 10 ? `0${day}` : day) +
              " " +
              (this.min ? monthName.shortname : monthName.name) +
              " " +
              year;
        }
      }
      return date;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.date {
  font-size: 1.2rem;
  color: $blue;

  &__author {
    margin-left: 2rem;
    font-weight: 600;
    color: #003d6a;
  }
}
</style>
